import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ONBOARDING_STEP_EVENT } from '../../../constants/analyticEvents';
import { pushEvent } from '../../../utilities/analytics';
import { setCurrentStep, setDataV2 } from '../onboardingSlice';
import WizardXpButton from '../components/WizardXpButton'
import { getWizardV2State } from '../wizardService';
import { isMobile } from '../../../utilities/helpers';
import ExperiencesStepDesktop from '../../wizardDesktop/steps/ExperiencesStepDesktop';

const ExperiencesStep = () => {
  const dispatch = useDispatch();

  const { formV2: form, step } = useSelector(state => state.onboarding);
  const data = getWizardV2State().whatThemeStep;

  const getStyleTheme = () => {
    const winterMonths = [1,2,3,10,11,12];
    const summerMonths = [4,5,6,7,8,9];

    let selectedTheme = 'all';

    switch (form.who?.id) {
      case 'family': {
        if (form.when.months.length > 0 && form.when.months.every(month => summerMonths.includes(+month))) {
          return selectedTheme = 'familySummer';
        }

        if (form.when.months.length > 0 && form.when.months.every(month => winterMonths.includes(+month))) {
          return selectedTheme = 'familyWinter';
        }

        selectedTheme = 'family';
        break;
      }

      case 'couple': {
        if (form.when.months.length > 0 && form.when.months.every(month => summerMonths.includes(+month))) {
          return selectedTheme = 'couplesSummer';
        }

        if (form.when.months.length > 0 && form.when.months.every(month => winterMonths.includes(+month))) {
          return selectedTheme = 'couplesWinter';
        }

        selectedTheme = 'couples';
        break;
      }

      case 'friends': {
        if (form.when.months.length > 0 && form.when.months.every(month => summerMonths.includes(+month))) {
          return selectedTheme = 'friendsSummer';
        }

        if (form.when.months.length > 0 && form.when.months.every(month => winterMonths.includes(+month))) {
          return selectedTheme = 'friendsWinter';
        }

        selectedTheme = 'friends';
        break;
      }

      case 'solo': {
        if (form.when.months.length > 0 && form.when.months.every(month => summerMonths.includes(+month))) {
          return selectedTheme = 'soloSummer';
        }

        if (form.when.months.length > 0 && form.when.months.every(month => winterMonths.includes(+month))) {
          return selectedTheme = 'soloWinter';
        }

        selectedTheme = 'solo';
        break;
      }

      default: {
        selectedTheme = 'all';
      }

    }

    return selectedTheme;
  }

  const themes = data.profiles?.[getStyleTheme()] || data.profiles.default;

  useEffect(() => {
    if (typeof form.experience === 'number') {
      const experience = themes.items.find(item => item.id === form.experience);

      if (experience) {
        dispatch(setDataV2({ experience }));
      } else {
        dispatch(setDataV2({ experience: null }))
      }
    }
  }, [dispatch, themes, form.experience])

  const handleClick = (item) => {
    if (form.experience?.id === item.id) {
      return dispatch(setDataV2({ experience: null }));
    }

    dispatch(setDataV2({ experience: item }));
  }

  const handleContinueClick = () => {
    dispatch(setCurrentStep(1));
    pushEvent(ONBOARDING_STEP_EVENT, {
      step,
      stepName: 'experiences',
      question: themes.title,
      selection: [form.experience?.id],
      expTxt: [form.experience?.text || ''],
      theme: getStyleTheme(),
      skipAvailable: !!(localStorage.getItem('onboardingCompleted')),
    });
  }

  if (!isMobile()) {
    return (
      <ExperiencesStepDesktop
        themes={themes}
        data={data}
        form={form}
        handleClick={handleClick}
        onContinueClick={handleContinueClick}
      />
    )
  }

  return (
    <div className="wizard-content-scrollable">
      <div className="wizard-step">
        <div className="wizard-step__title">{themes.title}</div>
        <div className="wizard-step__options wizard-experiences-step">
          <WizardXpButton
            label={data.showEverythingText}
            onClick={() => handleClick({ id: -1, text: 'all' })}
            active={form.experience?.id === -1}
            className="wizard-xp-button--default"
          />
          {themes.items.map((item, index) => (
            <WizardXpButton
              key={item.id}
              label={item.text}
              active={form.experience?.id === item.id}
              onClick={() => handleClick(item)}
              className={`slide-in-bottom animation-delay-${index * 50}`}
              imageUrl={item.photo}
            />
          ))}
        </div>
      </div>

      <div className="wizard-footer">
        <button className="wizard-control-button" onClick={handleContinueClick}>{data.buttonText}</button>
      </div>
    </div>
  )
}

export default ExperiencesStep
